import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
	name: 'percentage',
	standalone: true,
})
export class PercentagePipe implements PipeTransform {
	transform(value: string | number, ...args: unknown[]): number | string {
		if (typeof value === 'string' && isNaN(Number(value))) {
			return value // Si no es un número válido, devuelve el valor original
		}

		const numericValue = Number(value)
		return `${numericValue}%`
	}
}
